import React, { useEffect, useState } from "react";
import {
    MapPin,
    Navigation,
    LocateFixed,
    ShieldCheck,
    Clock,
    RefreshCw,
    Settings
} from "lucide-react";

import "./DeliveryLocation.css";

function DeliveryLocation() {

   const [status, setStatus] = useState("Checking...");
const [permission, setPermission] = useState("Checking...");
const [latitude, setLatitude] = useState("--");
const [longitude, setLongitude] = useState("--");
const [accuracy, setAccuracy] = useState("--");
const [address, setAddress] = useState("Fetching location...");
const [updatedAt, setUpdatedAt] = useState("");
const [loading, setLoading] = useState(false);

   const fetchLocation = () => {

    if (!navigator.geolocation) {

        setStatus("Not Supported");
        setPermission("Not Supported");
        setAddress("Geolocation is not supported.");

        return;

    }

    setLoading(true);

    navigator.geolocation.getCurrentPosition(

        async (position) => {

            const {

                latitude,
                longitude,
                accuracy

            } = position.coords;

            setLatitude(latitude.toFixed(6));
            setLongitude(longitude.toFixed(6));
            setAccuracy(`${accuracy.toFixed(1)} meters`);

            setStatus("Enabled");
            setPermission("Allowed");

            try {

                const response = await fetch(

                    `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`

                );

                const data = await response.json();

                setAddress(

                    `${data.address.suburb || ""}, 
                    ${data.address.city || data.address.town || ""},
                    ${data.address.state || ""},
                    ${data.address.country || ""}`

                );

            }

            catch {

                setAddress("Unable to fetch address");

            }

            setUpdatedAt(

                new Date().toLocaleTimeString()

            );

            setLoading(false);

        },

        () => {

            setStatus("Disabled");

            setPermission("Denied");

            setAddress("Location permission denied.");

            setLoading(false);

        },

        {

            enableHighAccuracy: true

        }

    );

};

  useEffect(() => {

    if (navigator.permissions) {

        navigator.permissions.query({

            name: "geolocation"

        }).then(result => {

            if (result.state === "granted") {

                setPermission("Allowed");

            }

            else if (result.state === "denied") {

                setPermission("Denied");

            }

            else {

                setPermission("Ask");

            }

        });

    }

    fetchLocation();

}, []);

    return (

        <div className="delivery-location-page">

            <div className="location-header">

                <h1>

                    Location Permission

                </h1>

                <p>

                    Manage your GPS and location settings.

                </p>

            </div>

            <div className="location-card">

                <div className="location-row">

                    <Navigation size={22} />

                    <div>

                        <h4>GPS Status</h4>

                        <span>{status}</span>

                    </div>

                </div>

                <div className="location-row">

                    <ShieldCheck size={22} />

                    <div>

                        <h4>Permission</h4>

                       <span>

{permission}

</span>

                    </div>

                </div>

                <div className="location-row">

                    <LocateFixed size={22} />

                    <div>

                        <h4>Accuracy</h4>

                       <span>

{accuracy}

</span>

                    </div>

                </div>

               <div className="location-row">

    <MapPin size={22}/>

    <div>

        <h4>Latitude</h4>

        <span>{latitude}</span>

    </div>

</div>

<div className="location-row">

    <MapPin size={22}/>

    <div>

        <h4>Longitude</h4>

        <span>{longitude}</span>

    </div>

</div>

<div className="location-row">

    <MapPin size={22}/>

    <div>

        <h4>Current Address</h4>

        <span>{address}</span>

    </div>

</div>

                <div className="location-row">

                    <Clock size={22} />

                    <div>

                        <h4>Last Updated</h4>

                        <span>

                            {updatedAt || "--"}

                        </span>

                    </div>

                </div>

            </div>

            <div className="location-buttons">

                <button

                    className="refresh-btn"

                    onClick={fetchLocation}

                >

                    <RefreshCw size={18} />

                   {

loading

? "Refreshing..."

: "Refresh Location"

}

                </button>

               

            </div>

        </div>

    );

}

export default DeliveryLocation;